// removed by extract-text-webpack-plugin
module.exports = {"taggingInput":"TaggingInput-taggingInput-3Z48k"};


//////////////////
// WEBPACK FOOTER
// ./modules/issFrontend/styles/TaggingInput.styl
// module id = ./modules/issFrontend/styles/TaggingInput.styl
// module chunks = 1